<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <IconButton
        type="button"
        class="rounded-full w-[34px] h-[34px] bg-[#2d3233]"
      >
        <SvgIcon :width="'16'" :height="'16'" icon="app-icons/help" />
      </IconButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent :side-offset="12" :align-offset="-6" :align="'end'">
      <DropdownMenuItem @click="onClickSortcuts">
        <SvgIcon
          class="opacity-50 ml-0 mr-2.5 my-0"
          icon="app-icons/shortcuts"
          :width="'18'"
        />
        <span>Shortcuts / Help</span>
      </DropdownMenuItem>
      <DropdownMenuItem as-child class="text-white hover:text-white">
        <a href="/docs" target="blank">
          <SvgIcon
            class="opacity-50 ml-0 mr-2.5 my-0"
            icon="app-icons/documentation"
            :width="'18'"
          />
          <span>Documentation</span>
        </a>
      </DropdownMenuItem>
      <DropdownMenuItem as-child class="text-white hover:text-white">
        <a
          href="https://www.youtube.com/playlist?list=PLP2s5PcDiBdbJUFiw8gu8gK1IyFboWxFH"
          target="blank"
        >
          <SvgIcon
            class="opacity-50 ml-0 mr-2.5 my-0"
            icon="app-icons/youtube"
            :width="'18'"
          />
          <span>Video tutorials</span>
        </a>
      </DropdownMenuItem>
      <DropdownMenuItem as-child class="text-white hover:text-white">
        <a href="https://discord.gg/atVXxAK" target="blank">
          <SvgIcon
            class="opacity-50 ml-0 mr-2.5 my-0"
            icon="app-icons/discord"
            :width="'20'"
          />
          <span>Ask us on Discord</span>
        </a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>

  <ShortcutsModal v-model:open="openShortcutsModal" />
</template>

<script setup>
import { IconButton } from '@ui/components/icon-button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@ui/components/dropdown-menu';
import SvgIcon from '@ui/components/SvgIcon.vue';

import { ref } from 'vue';
import ShortcutsModal from './ShortcutsModal.vue';

const openShortcutsModal = ref(false);

const onClickSortcuts = () => {
  openShortcutsModal.value = true;
};
</script>
